import React, { useEffect, useState } from "react";
import "./loader.scss";

const defaultMessages = [
  "Hold tight — hunting down insights!",
  "Just a sec — brewing your market intel.",
  "Hang on — we’re crunching the numbers.",
  "Almost there — charting the retail landscape.",
  "One moment — scoping out the competition.",
  "Sit tight — serving you fresh data.",
  "Stay tuned — we’re slicing and dicing.",
  "Keep calm — conquering the data jungle.",
  "Be right back — unearthing opportunities.",
  "Nearly there — polishing your insights.",
  "Grab a coffee — we’ll be right with you.",
  "Gearing up your dashboard now.",
  "Loading magic — please stand by!",
  "Fine-tuning your insights…",
  "Hold that thought — intel incoming!",
  "Spinning the data wheels…",
  "Almost locked and loaded!",
  "Hanging tight — finalizing details.",
  "Prepping your breakthrough stats…",
  "We’re on it — please stand by.",
  "Crunch time — powering up results.",
  "Your insights are on the way!"
];

const generalMessages = [
  "Just a moment—getting things ready.",
  "Please wait while we prepare everything.",
  "Almost done—loading up",
  "One sec—wrapping things up.",
  "Sit tight—we’re almost there.",
  "Loading… almost finished.",
  "Hold on—just tidying things up.",
  "One moment—finishing touches.",
  "Please wait… we’re almost ready.",
  "Almost there—thank you for waiting."
];

const priceReviewMessages = [
  "Sit tight — serving you fresh data.",
  "Just a sec — brewing your market intel.",
  "Hang on — we’re crunching the numbers.",
  "Hang tight — finalizing details.",
  "Your insights are on the way!",
  "Brewing the perfect price point…",
  "Aligning numbers for you…",
  "Polishing your price insights…",
  "Crafting your competitive edge…",
  "Serving fresh price data…",
  "Just a sec — brewing your price intel.",
  "Fine-tuning your price dashboard…"
];

const Loader = ({
  loading,
  doNotOverFlow,
  overlayOpacity = 0.25,
  dotColor = "#15304d",
  dotSize = 12,
  dotGap = 8,
  animationDuration = 0.6,
  messages = generalMessages,
  // messages = priceReviewMessages,
  messageInterval = 10000,
  showMessages = false,   
  liquidGlass = false   
}) => {
  const [msgIndex, setMsgIndex] = useState(0);

  useEffect(() => {
    if (!loading) return;

    setMsgIndex(Math.floor(Math.random() * messages.length));
    const iv = setInterval(() => {
      setMsgIndex(idx => (idx + 1) % messages.length);
    }, messageInterval);
    return () => clearInterval(iv);
  }, [loading, messages, messageInterval]);

  useEffect(() => {
    if (!doNotOverFlow) {
      document.body.style.overflow = loading ? "hidden" : "unset";
    }
  }, [loading, doNotOverFlow]);

  if (!loading) return null;

  const backdropClass = liquidGlass
    ? "loader-backdrop loader-backdrop--liquid-glass"
    : "loader-backdrop";
  const backdropStyle = liquidGlass
    ? {}
    : { background: `rgba(0,0,0,${overlayOpacity})` };

  return (
    <div className={backdropClass} style={backdropStyle}>
      <div className="loader-dots" style={{ gap: `${dotGap}px` }}>
        <span style={{
          width: dotSize,
          height: dotSize,
          background: dotColor,
          animationDuration: `${animationDuration}s`
        }} />
        <span style={{
          width: dotSize,
          height: dotSize,
          background: dotColor,
          animationDelay: `${animationDuration * 0.2}s`,
          animationDuration: `${animationDuration}s`
        }} />
        <span style={{
          width: dotSize,
          height: dotSize,
          background: dotColor,
          animationDelay: `${animationDuration * 0.4}s`,
          animationDuration: `${animationDuration}s`
        }} />
      </div>

      {showMessages && (
        <div className="loader-message" style={{ color: dotColor }}>
          {messages[msgIndex]}
        </div>
      )}
    </div>
  );
};

export default Loader;
